import { loadOnetrustSdk } from './load-onetrust-sdk'
import { LoggingServicePort } from '../../../shared/ports'
import { ConsentProviderConfig } from '../../ports'

const num_map: Record<number, string> = {
  1: 'first',
  2: 'second',
  3: 'third',
}

const MAX_RETRIES = 1

export async function loadOnetrustSdkWithRetry(
  config: ConsentProviderConfig,
  logger: LoggingServicePort
): Promise<void> {
  try {
    await loadOnetrustSdk(config)
  } catch (error) {
    let lastError = error
    for (let n = 1; n <= MAX_RETRIES; n++) {
      try {
        await loadOnetrustSdk(config)
        logger.logMessage(
          /*                                                                        */
          `Loading Onetrust SDK successfully recovered from an error: "${lastError}" after ${num_map[n]} retry.`
        )
        /*                                     */
        return
      } catch (retryError) {
        lastError = retryError
        if (n === MAX_RETRIES) {
          throw new Error(
            /*                                                                        */
            `Failed to load Onetrust SDK after ${num_map[n]} retry. Last error: "${retryError}"`
          )
        }
      }
    }
  }
}
